module.exports = __webpack_public_path__ + "img/icon_sm_khyscl.6fc25a87.png";